import { colors, fonts } from '../theme';

const industries = ['Automotive', 'Aerospace', 'EV & Battery', 'Textiles', 'Pharma'];

const Industries = () => (
  <section id="industries" style={{ padding: 'clamp(48px, 7vw, 80px) clamp(20px, 5vw, 48px)', background: colors.bgAlt }}>
    <div style={{ maxWidth: 1080, margin: '0 auto' }}>
      <p style={{ color: colors.teal, fontSize: 12.5, fontFamily: fonts.mono, letterSpacing: '0.14em', textTransform: 'uppercase', fontWeight: 600, marginBottom: 22 }}>Target Verticals</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
        {industries.map((name) => (
          <span key={name} style={{
            background: colors.bg,
            border: `2px solid ${colors.teal}`,
            borderRadius: 10,
            padding: '16px 30px',
            color: colors.navy,
            fontSize: 17,
            fontWeight: 700,
            letterSpacing: '0.01em',
            boxShadow: '0 4px 14px rgba(0,201,167,0.1)',
          }}>
            {name}
          </span>
        ))}
      </div>
    </div>
  </section>
);

export default Industries;
